import { useRouter } from '@tanstack/react-router';
import { useEffect, useRef } from 'react';
import { useRuntime } from '@/app/providers/runtime-provider';

/**
 * The home route ("/"): back from sign-in or step-up it sends the admin to the page they were on
 * (the BFF can only return to "/"), otherwise to the organisation list.
 */
export function HomeRedirect() {
  const { takeReturnPath } = useRuntime();
  const router = useRouter();
  // The saved path is read once, even when React runs the effect twice (strict mode).
  const target = useRef<string | null>(null);
  useEffect(() => {
    target.current ??= takeReturnPath() ?? '/organizations';
    router.history.replace(target.current);
  }, [router, takeReturnPath]);
  return null;
}
